module.exports = __webpack_public_path__ + "img/icon-gift-colored.db531982.svg";